import ValidateService from './validate';
import { ValidateConfig, ApiSetting } from './config';
import { t } from '../services/i18n/index';
const prevalidator = ValidateService(ValidateConfig, t);

const validator = (api, col, val) => {
	const setting = ApiSetting[api][col];

	const label = t(setting['label']);
	const validate = setting['validate'];

	return prevalidator.validate(label, validate, val);
};

export default validator;
